import _Constantes from './Constantes';
import _Config from './Config';

export const Constantes = _Constantes;
export const Config = _Config;